export default __webpack_public_path__ + "static/media/GAMEWORLD2.c4cb1ef7.png";